<template>
  <comment
    v-for="comment in comments"
    :comment="comment"
    :collection="comment.children"
    :key="comment.id"
  ></comment>
</template>

<script>
export default {
  props: ["comments", "collection"],
};
</script>

<style></style>
